import log from "loglevel";
import "./globals";

import "./modules/nav";
import "./modules/tax-toggle";
import "./modules/tabs";

if (document.querySelector(".image-gallery") !== null) {
    import("./modules/image-gallery").then(() => {
        log.info("Loaded image gall module");
    });
}

if (document.getElementById("mass-product") !== null) {
    import("./modules/mass-product").then(() => {
        log.info("Loaded mass product module");
    });
}

if (document.getElementById("cart") !== null) {
    import("./modules/cart").then(() => {
        log.info("Loaded cart module");
    });
}

if (document.getElementById("checkout") !== null) {
    import("./modules/checkout").then(() => {
        log.info("Loaded checkout module");
    });
}

if (document.querySelector(".image-zoom") !== null) {
    import("./modules/image-zoom").then(() => {
        log.info("Loaded image zoom module");
    });
}


$(".with-tooltip").click(function () {
    console.log("click");
    $(this).find(".tooltiptext").toggle();
})